module.exports = __webpack_public_path__ + "img/warsztaty-2.db9559e9.jpg";